module.exports = __webpack_public_path__ + "print.360b181763eb6e706782f3a09604f773.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/print.svg
// module id = 477
// module chunks = 0